import { useState, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler";
import FormTypeDropdown from "src/Pages/forms/templates/components/FormTypeDropdown";
import WOService from "src/Services/API/wo.service";
import { handleError } from "src/Common/function";
import WODropdown from "src/Components/filter/components/WODropdown";

const STATUSES = [
  { value: 0, label: "Draft" },
  { value: 1, label: "Assigned" },
  { value: 2, label: "Filled" },
];

const FREQUENCIES = [
  { value: 0, label: "One Time" },
  { value: 1, label: "Weekly" },
  { value: 2, label: "Monthly" },
  { value: 3, label: "Quarterly" },
  { value: 4, label: "Semi-Annual" },
  { value: 5, label: "Annual" },
];

const FilterDropdown = ({ options, selectedValue, onSelect, placeholder = "Select" }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedLabel =
    selectedValue !== null && selectedValue !== undefined && selectedValue !== ""
      ? options.find((o) => o.value === Number(selectedValue))?.label || placeholder
      : placeholder;

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500 cursor-pointer"
        >
          <span className="font-OpenSansRegular text-[12px]">{selectedLabel}</span>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            {options.map((opt) => (
              <li
                key={opt.value}
                onClick={() => {
                  onSelect(opt.value);
                  setIsOpen(false);
                }}
                className="px-4 py-1 cursor-pointer hover:bg-gray-200"
              >
                <span className="font-OpenSansRegular text-[12px]">{opt.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

const FormFilterView = ({ onApply, onClear }) => {
  const [filterType, setFilterType] = useState(null);
  const [filterFrequency, setFilterFrequency] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterWoNumber, setFilterWoNumber] = useState("");

  const [woNumbers, setWoNumbers] = useState([]);

  useEffect(() => {
    fetchWoNumbers();
  }, []);

  const fetchWoNumbers = () => {
    WOService.getAllOrderNumberWithKeyword("", 0)
      .then((response) => {
        if (response.status === 200) {
          setWoNumbers((response.data || []).map((item) => String(item)));
        }
      })
      .catch((error) => handleError(error));
  };

  const handleApply = () => {
    onApply({
      formType: filterType !== null ? String(filterType) : "",
      frequency: filterFrequency,
      status: filterStatus,
      woNumber: filterWoNumber,
    });
  };

  const handleClear = () => {
    setFilterType(null);
    setFilterFrequency("");
    setFilterStatus("");
    setFilterWoNumber("");
    onClear();
  };

  return (
    <div className="flex items-center gap-6 pb-4 flex-wrap">
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-OpenSansMedium font-[600] text-titleColor whitespace-nowrap">
          by Type:
        </span>
        <div className="w-[200px]">
          <FormTypeDropdown
            selectedValue={filterType}
            onSelect={(val) => setFilterType(val)}
          />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-OpenSansMedium font-[600] text-titleColor whitespace-nowrap">
          by Frequency:
        </span>
        <div className="w-[160px]">
          <FilterDropdown
            options={FREQUENCIES}
            selectedValue={filterFrequency}
            onSelect={(val) => setFilterFrequency(String(val))}
          />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-OpenSansMedium font-[600] text-titleColor whitespace-nowrap">
          by Status:
        </span>
        <div className="w-[130px]">
          <FilterDropdown
            options={STATUSES}
            selectedValue={filterStatus}
            onSelect={(val) => setFilterStatus(String(val))}
          />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-OpenSansMedium font-[600] text-titleColor whitespace-nowrap">
          by WO#:
        </span>
        <div className="w-[130px]">
          <WODropdown
            options={woNumbers}
            selectedWO={filterWoNumber}
            onSelect={(value) => setFilterWoNumber(String(value))}
          />
        </div>
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <div
          onClick={handleApply}
          className="px-5 h-[24px] text-[10px] rounded-[4px] bg-blueColor text-white font-OpenSansRegular font-[600] flex items-center justify-center cursor-pointer"
        >
          APPLY
        </div>
        <div
          onClick={handleClear}
          className="px-5 h-[24px] text-[10px] rounded-[4px] border-[1px] border-borderColor text-[#67737E] font-OpenSansRegular font-[600] flex items-center justify-center cursor-pointer"
        >
          CLEAR
        </div>
      </div>
    </div>
  );
};

export default FormFilterView;
